import React, {FC, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {cookieStore} from 'libs/storage/storage';

import s from './privacyPolicyBanner.scss';
import {IS_VISIBLE_PRIVACY_POLICY} from './constants/cookies';
import {GENERAL, sendMobileAnalyticsPerSession} from '@optimaxdev/analytics/mobile';

const sendAnalytics = (label: string, isInteraction = true) => {
    sendMobileAnalyticsPerSession({
        event: GENERAL.COOKIES_BANNER,
        label: {label},
        isInteraction,
    });
};

/**
 *  Experiment for show banner for privacy policy
 * @return {JSX.Element} - PrescriptionPopup component
 */
export const PrivacyPolicyBanner: FC = () => {
    const [isVisible, setIsVisible] = useState(true);

    const hide = () => {
        cookieStore.set(IS_VISIBLE_PRIVACY_POLICY, false);
        setIsVisible(false);
        window.removeEventListener('click', hide);
        window.removeEventListener('scroll', hide);
    };

    const onSendAnalytics = (label: string) => () => {
        sendAnalytics(label);
    };

    useEffect(() => {
        sendAnalytics('Showed', false);
        window.addEventListener('click', hide);
        window.addEventListener('scroll', hide);
        return () => {
            window.removeEventListener('click', hide);
            window.removeEventListener('scroll', hide);
        };
    }, []);

    return (
        <>
            {isVisible && (
                <div
                    className={s.banner}
                    role="dialog"
                    aria-modal="true"
                    aria-describedby="policy-banner-message"
                >
                    <div id="policy-banner-message" className={s.text}>
                        <p className={s.firstParagraph}>
                            GlassesUSA.com uses cookies, script code, session replay software, and
                            similar tracking technologies to collect data, track site usage and
                            monitor your interactions on our sites to improve user experience.
                        </p>
                        <p>
                            By continuing using our sites, you consent to our use of these
                            technologies and agree to our{' '}
                            <Link
                                to="terms-and-conditions"
                                className={s.link}
                                onClick={onSendAnalytics('Terms and Conditions')}
                            >
                                Terms and Conditions
                            </Link>{' '}
                            and{' '}
                            <Link
                                to="privacy-policy"
                                className={s.link}
                                onClick={onSendAnalytics('Privacy Policy')}
                            >
                                Privacy Policy
                            </Link>
                            . To manage your cookie selection, please see our Privacy Preferences.
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={hide}
                        className={s.btn}
                        aria-label="close policy banner"
                    >
                        <span className={s.cross} tabIndex={-1} />
                    </button>
                </div>
            )}
        </>
    );
};
